import { gsapSingleton, scrollTriggerSingleton } from "../gsap";
const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();
import $ from 'jquery';
import Component from '../models/Component';

export default class HeroImage extends Component {
  constructor(element, context) {
    super(element, context);

    const container = this.element.find('.img-container');

    //MOBILE
    if (window.innerWidth > 768) { 

      const scrollTriggerConfig = {
        trigger: this.element,
        start: "top center",
        end: "center top",
        scrub: 1,
        markers: false,
      };

      gsap.fromTo(container, 
        {
          width: '75%',
          borderRadius: '50%',
        },
        {
          width: '100%',
          borderRadius: 0,
          scrollTrigger: scrollTriggerConfig
        }
      );

    } 

    //DESKTOP
    else  {

      const scrollTriggerConfig = {
        trigger: this.element,
        start: "top center",
        end: "center top",
        scrub: 1,
        markers: false,
      };

      gsap.fromTo(container, 
        {
          width: '140vw',
          borderRadius: '100%',
        },
        {
          width: '100vw',
          borderRadius: 0,
          scrollTrigger: scrollTriggerConfig
        }
      );

    }
  }
}
